import React from "react";
import {
  Footprints, ListChecks, Target, ArrowUp, Fire, Medal, Trophy, GraduationCap,
  Calculator, BookOpen, GlobeHemisphereWest, Flask, MapTrifold, ChatCircleText, Lock
} from "@phosphor-icons/react";

const ICONS = {
  "footprint": Footprints,
  "list-checks": ListChecks,
  "target": Target,
  "arrow-up": ArrowUp,
  "fire": Fire,
  "medal": Medal,
  "trophy": Trophy,
  "graduation": GraduationCap,
  "calculator": Calculator,
  "book": BookOpen,
  "globe": GlobeHemisphereWest,
  "flask": Flask,
  "map": MapTrifold,
  "chat": ChatCircleText,
};

export default function BadgeIcon({ badge }) {
  const Icon = ICONS[badge.icon] || Trophy;
  const earned = badge.earned;
  return (
    <div
      className={`bg-white rounded-2xl p-3 flex flex-col items-center justify-center gap-2 aspect-square text-center transition-all ${earned ? "shadow-md" : "opacity-40 grayscale"}`}
      style={{ borderTop: `4px solid ${earned ? badge.color : "#D1D5DB"}` }}
      data-testid={`badge-${badge.key}`}
      title={badge.desc}
    >
      <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: earned ? `${badge.color}22` : "#F3F0EB" }}>
        {earned ? (
          <Icon size={26} weight="duotone" color={badge.color} />
        ) : (
          <Lock size={22} weight="duotone" color="#8D99AE" />
        )}
      </div>
      <div className="font-outfit font-bold text-xs text-brand-ink leading-tight" style={{ minHeight: "2.4em" }}>{badge.name}</div>
    </div>
  );
}
